<section class="wrapper flex flex-column justify-center items-center h-full w-full absolute">
    <app-loading-animation class="h-auto" width="140px" height="140px"></app-loading-animation>
    <div class="font-main text-2xl text-navy-90">
        {{ description | translate }}
    </div>
</section>